import { render, staticRenderFns } from "./fireFightingPermitChecklistItem.vue?vue&type=template&id=3ff1a377"
import script from "./fireFightingPermitChecklistItem.vue?vue&type=script&lang=js"
export * from "./fireFightingPermitChecklistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff1a377')) {
      api.createRecord('3ff1a377', component.options)
    } else {
      api.reload('3ff1a377', component.options)
    }
    module.hot.accept("./fireFightingPermitChecklistItem.vue?vue&type=template&id=3ff1a377", function () {
      api.rerender('3ff1a377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/base/fireFightingPermitChecklistItem.vue"
export default component.exports